<script>
  export let progressPer = '';
  export let progressPerValue = '';
  let divWidth = 60;
</script>

<div class="progress-bar-main">
  <span
    class="progress-bar-inner"
    style="width: {divWidth}px;"
  >
    <span
      class="progress-bar"
      style="width: {Math.round((progressPerValue * divWidth) / 100)}px;"
    ></span>
  </span>
  <span style="float: left;font-size: 10px;">{progressPer}%</span>
</div>

<style lang="scss">
  .progress-bar-main {
    height: 12px;
    line-height: 12px;
    width: 110px;
  }
  .progress-bar-inner {
    display: inline-block;
    float: left;
    margin-right: 3px;
    background-color: #e8e9ed;
    border-radius: 6px;
  }
  .progress-bar {
    background: #206bc4;
    height: 10px;
    margin-right: 3px;
    float: left;
    border-radius: 6px !important;
  }
  :global(.overdue-row .progress-bar) {
    background: #f7524f !important;
  }
</style>
